import { useState, useEffect } from "react";
import { Table } from "../../components/others/Table";
import { useModal } from "../../hooks";
import LavorisService from "../../services/LavorisService";
import AddRRHHTurns from "../others/userModule/RRHHTurns/addRRHHTurns";
import EditRRHHTurns from "../others/userModule/RRHHTurns/editRRHHTurns";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { getUserRolesTableColumns } from "./userRolesTableColumns";

const ADD_RRHH_TURNS_MODAL = "addRRHHTurnsModal";
const EDIT_RRHH_TURNS_MODAL = "editRRHHTurnsModal";

const RRHHTurns = () => {
  const LavorisInstance = LavorisService.getInstance();

  // useStates
  const [tableLoading, setTableLoading] = useState(true);
  const { openModal, closeModal, isActive } = useModal();
  const [RRHHTurns, setRRHHTurns] = useState<any[]>([]);
  const [RRHHTurn, setRRHHTurn] = useState<any>(null);


  const getItems = async () => {
    setTableLoading(true);
    try {
      const response = await LavorisInstance.User.findUsersByRoleAlias(
        "RRHH_APPOINTMENTS",
      );
      setRRHHTurns(response);
    } catch (error) {
      console.log(error);
    } finally {
      setTableLoading(false);
    }
  };
  useEffect(() => {
    const getData = async () => {
      await getItems();
    };
    getData();
  }, []);

  // Configuración de columnas para la tabla
  const requestedTurnsColumns = getUserRolesTableColumns((rowData) => {
    openModal(EDIT_RRHH_TURNS_MODAL, rowData.id);
    setRRHHTurn(rowData);
  });

  return (
    <>
      <InfiniteTable
        data={RRHHTurns}
        columns={requestedTurnsColumns}
        loading={tableLoading}
        hasMore={false}
        onLoadMore={() => { }}
        height={300}
        emptyMessage="Momentáneamente no hay datos para mostrar"
        loadingMessage={RRHHTurns.length === 0 ? "Cargando datos..." : "Buscando más datos..."}
        striped
        hover
        bordered
      />



      {isActive(ADD_RRHH_TURNS_MODAL) && (
        <AddRRHHTurns
          show
          urlTittle={ADD_RRHH_TURNS_MODAL}
          onClose={() => closeModal(ADD_RRHH_TURNS_MODAL)}
          modalTittle="Agregar RRHH de Turnos"
          tableLoading={getItems}
        />
      )}

      {isActive(EDIT_RRHH_TURNS_MODAL) && (
        <EditRRHHTurns
          show
          urlTittle={EDIT_RRHH_TURNS_MODAL}
          onClose={() => closeModal(EDIT_RRHH_TURNS_MODAL)}
          modalTittle="Editar RRHH de Turnos"
          data={RRHHTurn}
          tableLoading={getItems}
        />
      )}
    </>
  );
};

export default RRHHTurns;
